module.exports = __webpack_public_path__ + "img/cover.363d5f9c.png";